import { render } from "./HoldetsDeltagere.vue?vue&type=template&id=0ce03120"
import script from "./HoldetsDeltagere.vue?vue&type=script&lang=js"
export * from "./HoldetsDeltagere.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__